<template>
  <v-col>
    <h2 class="subtitle-1">CRON</h2>
    <v-card
        v-for="(cron, name) in crons"
        :key="name"
        class="pa-2"
        outlined
        tile
    >
      <h3 class="subtitle-2">{{ name }}</h3>
      <v-list two-line v-if="cron.last_result">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{ cron.last_execution }}</v-list-item-title>
            <v-list-item-subtitle>Last execution at</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{ cron.last_result }}</v-list-item-title>
            <v-list-item-subtitle>Last result</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <div v-else>
        No data
      </div>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "cron",
  props: {
    crons: {
      required: true,
      type: Object,
    }
  }
}
</script>
